import React from 'react';
import { CtaButton } from './CtaButton';
export function ClosingSection() {
  return <section className="bg-ink py-14 text-cream md:py-28" data-id="element-31" data-mp="otc9r4h0nb1a">
      <div className="mx-auto max-w-3xl px-5 text-center md:px-8" data-id="element-32" data-mp="ov5fmhjt1r88">
        <h2 className="font-serif text-[2rem] font-semibold leading-tight text-gold-light sm:text-4xl md:text-6xl" data-id="element-33" data-mp="12twtc2ur9avu">
          Tu momento con Dios puede empezar hoy
        </h2>
        <p className="mt-6 text-[15px] leading-relaxed text-cream/80 sm:text-lg md:mt-8" data-id="element-34" data-mp="1cqhtoavtxxtc">
          A veces buscamos respuestas en medio del ruido, cuando lo que necesitamos es detenernos un instante.
        </p>
        <p className="mx-auto mt-6 max-w-xl font-serif text-xl italic leading-relaxed text-cream sm:text-2xl md:mt-8 md:text-3xl" data-id="element-35" data-mp="1lia26g1amwva">
          Abrí la Biblia. Leé con calma. Reflexioná sobre cada palabra. Hacé una oración desde el corazón.
        </p>
        <div className="mx-auto mt-6 max-w-2xl space-y-3 text-[15px] leading-relaxed text-cream/80 sm:text-lg md:mt-8 md:space-y-4" data-id="element-36" data-mp="1vf6d0senzv30">
          <p data-id="element-37" data-mp="22cvpa5yrrpg3">Permitite construir, paso a paso, una relación más consciente con tu fe.</p>
          <p data-id="element-38" data-mp="27b6z4gp2dzyb">
            El Poder de los Salmos puede acompañarte en ese camino con recursos digitales que vas a poder consultar a tu
            propio ritmo.
          </p>
          <p className="text-cream" data-id="element-39" data-mp="2ccweu9n8f1sq">
            No hace falta empezar con grandes cambios. Empezá dedicando unos minutos a lo que realmente importa para vos.
          </p>
        </div>
        <div className="mt-8 md:mt-10" data-id="element-40" data-mp="2l93zzpajwsis">
          <CtaButton variant="light" size="lg" href="#oferta" data-id="element-41" data-mp="2q9roa37eav9b">
            Quiero descubrir el poder de los Salmos
          </CtaButton>
        </div>
      </div>
    </section>;
}